<script setup lang="ts">
import type { Product } from '~/types'

defineProps<{
  products: Product[]
  loading?: boolean
}>()
</script>

<template>
  <div>
    <!-- Loading state - horizontal skeleton cards -->
    <div v-if="loading" class="flex flex-col gap-4">
      <div v-for="i in 8" :key="i" class="flex bg-white rounded-xl border border-neutral-200/60 overflow-hidden">
        <USkeleton class="w-28 sm:w-36 shrink-0" />
        <div class="flex-1 p-4">
          <USkeleton class="h-5 w-3/4 mb-2" />
          <USkeleton class="h-4 w-1/2 mb-3" />
          <div class="flex gap-2">
            <USkeleton class="h-8 w-16" />
            <USkeleton class="h-8 w-20" />
          </div>
        </div>
      </div>
    </div>

    <!-- Products list - horizontal layout (empty state handled by parent) -->
    <div
      v-else
      class="flex flex-col gap-4"
    >
      <CatalogProductCard
        v-for="product in products"
        :key="product.id"
        :product="product"
      />
    </div>
  </div>
</template>
